import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Goals = ({ control }) => {
  const { availableGoals, availableStaffGoals } = useSelector(
    (state) => state.organizations.commonSettings
  );

  return (
    <>
      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Available goals</p>
          <Controller
            control={control}
            name="available_goals"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  includeSelectAll
                  enableOnly
                  options={availableGoals}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Available staff goals</p>
          <Controller
            control={control}
            name="available_staff_goals"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  includeSelectAll
                  enableOnly
                  options={availableStaffGoals}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>
    </>
  );
};
